module.exports = __webpack_public_path__ + "img/nopic-meds.c06b0209.jpg";